@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;

.wrapper {
  display: block;
  overflow: hidden;
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  border-radius:  hevo-toolkit-variables.$border-radius-md;

  &.noBorder {
    border: 0;
  }

  &.error {
    border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$error;
  }

  th {
    display: flex;
    align-items: center;
    height: 48px;
  }

  .listWrapper {
    max-height: 300px;
    display: block;
    overflow: auto;
    height: 100%;
  }
}

.noBorder {
  border: 0 !important;
}

.groupListWrapper {
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  border-radius:  hevo-toolkit-variables.$border-radius-md;
}

.childWrapper {
  display: block;
  overflow: scroll;
  max-height: 180px;
}

.noBackground {
  background: transparent !important;
}

.groupHeader {
  border-top: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;

  &:first-child {
    border-top: 0;
  }

  td {
    height: 40px !important;
  }
}

.groupItems {
  td {
    padding-left:  hevo-toolkit-variables.$spacer * 2.625 !important;
    height: 34px !important;
  }
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  min-width: fit-content;
  @include  hevo-toolkit-mixins.spinning-animation('.icon', 2s);
}

.virtualizedContainer {
  max-height: 250px;

  .virtualizedWrapper {
    .virtualizedRow.odd {
      background-color:  hevo-toolkit-variables.$surface-bg-alternate;
    }

    .virtualizedRow {
      padding: 0  hevo-toolkit-variables.$spacer * 1.25;
      height: 56px;
      border: none;
    }
  }
}
